/*
 *
 * UncompletedTurnReportsCard
 *
 */

import { FormattedMessage } from 'react-intl';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ScrollablePaper from '~/components/ScrollablePaper';
import TurnReportListItem from '~/components/TurnReportListItem';
import { useCreateTurnReport } from '~/hooks/api/useCreateTurnReport';
import { TurnDto } from '~/generated';
import messages from './messages';
import { useNavigate, useLocation } from '@tanstack/react-router';

type UncompletedTurnReportsCardProps = {
  pendingTurnReports: TurnDto[];
};

export const UncompletedTurnReportsCard = (
  props: UncompletedTurnReportsCardProps
) => {
  const createTurnReportMutation = useCreateTurnReport();
  const navigate = useNavigate();
  const location = useLocation();
  const goToTurnReport = async (turn: {
    id?: number;
    turnReportId?: number | null;
  }) => {
    if (!turn.id) {
      throw new Error('turn with id given');
    }
    if (!turn.turnReportId) {
      const turnReport = await createTurnReportMutation.mutateAsync({
        turnId: turn.id,
      });
      return navigate({
        to: `/turn-reports/${turnReport.id}`,
        search: { from: location.pathname },
      });
    }
    return navigate({
      to: `/turn-reports/${turn.turnReportId}`,
      search: { from: location.pathname },
    });
  };
  return (
    <div data-test="uncompleted-turn-reports-card">
      <ScrollablePaper
        title={<FormattedMessage {...messages.uncompletedTurnReports} />}
      >
        <List style={{ padding: 0 }}>
          {props.pendingTurnReports.length > 0 ? (
            props.pendingTurnReports.map((turn) =>
              turn.shift ? (
                <TurnReportListItem
                  key={turn.shift.id}
                  isClosed={false}
                  turn={turn}
                  showCompletedState={false}
                  onClick={() => goToTurnReport(turn)}
                />
              ) : null
            )
          ) : (
            <ListItem>
              <ListItemText
                primary={
                  <FormattedMessage {...messages.noUncompletedTurnReports} />
                }
              />
            </ListItem>
          )}
        </List>
      </ScrollablePaper>
    </div>
  );
};

export default UncompletedTurnReportsCard;
